import React, { useState } from 'react';
import { ShieldIcon, AlertTriangleIcon } from '../icons.js';
import { TRUSTED_DEV_PUBLIC_KEY_B64 } from '../crypto/verify-package.js';

export interface SignatureBadgeProps {
  moduleId: string;
  manifest: any;
}

export const SignatureBadge: React.FC<SignatureBadgeProps> = ({ moduleId, manifest }) => {
  const [isOpen, setIsOpen] = useState(false);

  const isVerified = manifest?.signature && manifest?.bundleDigest;

  return (
    <div style={{ position: 'relative', display: 'inline-block' }}>
      <button
        data-testid={`badge-signature-${moduleId}`}
        onClick={() => setIsOpen(!isOpen)}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          padding: '2px 8px',
          borderRadius: '12px',
          background: isVerified ? 'rgba(16, 185, 129, 0.15)' : 'rgba(245, 158, 11, 0.15)',
          border: `1px solid ${isVerified ? 'rgba(16, 185, 129, 0.4)' : 'rgba(245, 158, 11, 0.4)'}`,
          color: isVerified ? '#34d399' : '#fbbf24',
          cursor: 'pointer',
          fontSize: '10px',
          fontWeight: 700,
          fontFamily: 'monospace',
        }}
      >
        {isVerified ? (
          <>
            <ShieldIcon size={12} color="#34d399" />
            Ed25519 Verified
          </>
        ) : (
          <>
            <AlertTriangleIcon size={12} color="#fbbf24" />
            Unverified
          </>
        )}
      </button>

      {isOpen && (
        <div
          data-testid="popover-signature-proof"
          style={{
            position: 'absolute',
            top: '100%',
            right: 0,
            marginTop: '8px',
            width: '320px',
            background: '#0f172a',
            border: '1px solid rgba(56, 189, 248, 0.3)',
            borderRadius: '12px',
            padding: '16px',
            zIndex: 100,
            boxShadow: '0 10px 25px -5px rgba(0, 0, 0, 0.5)',
            color: '#f8fafc',
            textAlign: 'left',
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '12px' }}>
            <h4 style={{ margin: 0, fontSize: '13px', color: '#38bdf8' }}>Cryptographic Proof</h4>
            <button
              onClick={() => setIsOpen(false)}
              style={{ background: 'none', border: 'none', color: '#94a3b8', cursor: 'pointer' }}
            >
              ✕
            </button>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <div style={{ fontSize: '10px', color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase' }}>Public Key ID</div>
              <div style={{ fontSize: '11px', color: '#f8fafc', fontFamily: 'monospace', wordBreak: 'break-all', background: 'rgba(255,255,255,0.05)', padding: '4px 6px', borderRadius: '4px', marginTop: '2px' }}>
                {TRUSTED_DEV_PUBLIC_KEY_B64}
              </div>
            </div>

            <div>
              <div style={{ fontSize: '10px', color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase' }}>SHA-256 Digest</div>
              <div style={{ fontSize: '11px', color: '#34d399', fontFamily: 'monospace', wordBreak: 'break-all', background: 'rgba(255,255,255,0.05)', padding: '4px 6px', borderRadius: '4px', marginTop: '2px' }}>
                {manifest?.bundleDigest || 'N/A'}
              </div>
            </div>

            <div>
              <div style={{ fontSize: '10px', color: '#94a3b8', fontWeight: 700, textTransform: 'uppercase' }}>Raw Manifest</div>
              <div style={{ fontSize: '10px', color: '#cbd5e1', fontFamily: 'monospace', whiteSpace: 'pre-wrap', background: 'rgba(0,0,0,0.5)', padding: '8px', borderRadius: '6px', marginTop: '4px', maxHeight: '150px', overflowY: 'auto' }}>
                {JSON.stringify(manifest, null, 2)}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
